import intro1A from './plan/1-A-intro';
import stage1A from './plan/1-A-stage';
import intro2A from './plan/2-A-intro';
import stage2A from './plan/2-A-stage';
import intro3A from './plan/3-A-intro';
import intro4A from './plan/4-A-intro';
import intro5A from './plan/5-A-intro';
import stage5A from './plan/5-A-stage';
import intro6A from './plan/6-A-intro';
import stage6A from './plan/6-A-stage';

const plan = [
  {
    title: '初级会计职称',
    professionId: '1',
    isShowMethods: true,
    detail: [
      {
        type: 'A',
        name: '初级会计学习计划',
        shortname: '学习计划',
        imgUrl: require('assets/img/plan.png'),
        target: '适合学习时间较多，自学能力较强的学员',
        introUrl: 'https://m.zhuokao360.com/plan/1/A/',
        startUrl: 'https://m.zhuokao360.com/plan/1/A/start',
        intro: intro1A,
        start: {
          isOpen: false,
          isDivide: true,
          stage: stage1A,
        },
      },
    ],
  },
  {
    title: '中级会计职称',
    professionId: '2',
    isShowMethods: true,
    detail: [
      {
        type: 'A',
        name: '中级会计学习计划',
        shortname: '学习计划',
        imgUrl: require('assets/img/plan.png'),
        target: '适合学习时间较多，自学能力较强的学员',
        introUrl: 'https://m.zhuokao360.com/plan/2/A/',
        startUrl: 'https://m.zhuokao360.com/plan/2/A/start',
        intro: intro2A,
        start: {
          isOpen: false,
          isDivide: true,
          stage: stage2A,
        },
      },
    ],
  },
  {
    title: '注册会计师',
    professionId: '3',
    isShowMethods: true,
    detail: [
      {
        type: 'A',
        name: '注册会计师学习计划',
        shortname: '学习计划',
        imgUrl: require('assets/img/plan.png'),
        target: '注会六神计划，一年过六门不是梦',
        introUrl: 'https://m.zhuokao360.com/plan/3/A/',
        startUrl: '',
        intro: intro3A,
        start: {
          isOpen: false,
          isDivide: false,
          stage: [],
        },
      },
    ],
  },
  {
    title: '管理会计师',
    professionId: '4',
    isShowMethods: true,
    detail: [
      {
        type: 'A',
        name: '管理会计师学习计划',
        shortname: '学习计划',
        imgUrl: require('assets/img/plan.png'),
        target: '适合于备考时间比较少，想一次拿证的同学',
        introUrl: 'https://m.zhuokao360.com/plan/4/A/',
        startUrl: '',
        intro: intro4A,
        start: {
          isOpen: false,
          isDivide: false,
          stage: [],
        },
      },
    ],
  },
  {
    title: '会计实操',
    professionId: '5',
    isShowMethods: false,
    detail: [
      {
        type: 'A',
        name: '会计实操学习计划',
        shortname: '学习计划',
        imgUrl: require('assets/img/plan.png'),
        target: '30天急速上岗，会计小白的升职法宝',
        introUrl: 'https://m.zhuokao360.com/plan/5/A/',
        startUrl: 'https://m.zhuokao360.com/plan/5/A/start',
        intro: intro5A,
        start: {
          isOpen: true,
          isDivide: false,
          stage: stage5A,
        },
      },
    ],
  },
  {
    title: '顺带过税务师',
    professionId: '6',
    isShowMethods: true,
    detail: [
      {
        type: 'A',
        name: '税务师学习计划',
        shortname: '学习计划',
        imgUrl: require('assets/img/plan.png'),
        target: '顺带过税务师，多学40天，多拿一个证',
        introUrl: 'https://m.zhuokao360.com/plan/6/A/',
        startUrl: 'https://m.zhuokao360.com/plan/6/A/start',
        intro: intro6A,
        start: {
          isOpen: false,
          isDivide: false,
          stage: stage6A,
        },
      },
    ],
  },
];

export default plan;
